import React from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import CascadingMenuItem from 'src/components/common/CascadingMenuItem';
import utils from 'src/utils/utils';

/*
selectedCriterias : tous les criteres selectionnes appartenant au GroupType (props.groupName) 
availaibleCriterias : tous les criteres disponibles appartenant au GroupType (props.groupName)
retrive allGroupedAvailaibleCrit
// TODO !important: describe FROM => TO data
 */
const mapCriterias = (availaibleCriterias, addCriteria, isWritable, selectedCriterias) => {
  const availableSubGroupFields = availaibleCriterias.filter(
    c => !!c.parentDescriptor && c.parentDescriptor.descriptors.length > 1
  ); // tous les descripteurs de champ groupé de ce GroupType, sauf ceux qui n'ont qu'un champ (attention notion GroupeType et champ de type GROUP différents)

  // build a list of unique descriptors of type 'GROUP' from GROUPedFieldList (availableSubGroupFields) parentdescriptors.
  const availableGroupFieldsDescriptors = availableSubGroupFields
    .map(subField => subField.parentDescriptor)
    // add only if descriptor is not already in list
    .reduce(
      (parentDescriptors, parentDescriptor) =>
        parentDescriptors.map(p => p.key).includes(parentDescriptor.key)
          ? parentDescriptors
          : parentDescriptors.concat(parentDescriptor),
      []
    );

  const selectedCriteriaKeys = Object.keys(selectedCriterias);

  // list des fieldsKeys de champ GROUP présents dans la sélection
  const selectedGroupFieldKeys = availableGroupFieldsDescriptors
    .map(c => c.key)
    .filter(agfkey => selectedCriteriaKeys.includes(agfkey));

  // build subFields map
  // map of selectedSubGroupFields by GROUPfieldKey
  const groupSubfieldsMapByGroupFieldKey = availableGroupFieldsDescriptors.reduce(
    (result, groupFieldDescriptor) =>
      selectedGroupFieldKeys.includes(groupFieldDescriptor.key)
        ? {
            ...result,
            [groupFieldDescriptor.key]: availableSubGroupFields.filter(
              sub => sub.parentDescriptor.key === groupFieldDescriptor.key
            ),
          }
        : result,
    {}
  );

  // groupedAvailableCriterias :
  // on prépare une liste avec les sous champs GROUP 'regroupés' s'ils existent déjà dans la sélection :
  // pour chaque occurence sélectionnée, un objet groupe est créé, et contiendra une liste de chaque sous champ correspondant. Cet objet est ajouté à la liste.
  // si NON,(pas sélectionné), chaque sous champ est rajouté tel quel à la liste.
  const criteriaMenuItems = availaibleCriterias
    .filter(
      // si c n'a pas de parentDescriptor ou si le champ GROUP n'est pas sélectionné :(=si le champ n'est pas un groupe OU s'il n'est pas sélectionné(peut etre un group, non sélectionné))
      c =>
        !c.parentDescriptor ||
        c.parentDescriptor.descriptors.length < 2 || // les champ GROUP qui n'ont qu'un champ
        !selectedGroupFieldKeys.includes(c.parentDescriptor.key)
    )
    .map(c => ({
      ...c,
      onClick: isWritable
        ? e => {
            e.preventDefault();
            addCriteria(c);
          }
        : e => {
            e.preventDefault();
          },
      label: i18next.t(`smartmessaging.massAction.filterLabel.${c.key}`),
    }));

  selectedGroupFieldKeys.forEach(groupFieldKey => {
    const groupValues = selectedCriterias[groupFieldKey].criteriaValues;

    criteriaMenuItems.push({
      subMenuItems: groupSubfieldsMapByGroupFieldKey[groupFieldKey].map(i => ({
        ...i,
        onClick: isWritable
          ? e => {
              e.preventDefault();
              addCriteria(i);
            }
          : e => {
              e.preventDefault();
            },
        label: i18next.t(`smartmessaging.massAction.filterLabel.${i.key}`),
      })),
      label: i18next.t('smartmessaging.massAction.newGroupedFilter'),
    });

    Object.keys(groupValues).forEach(uniqueId => {
      criteriaMenuItems.push({
        subMenuItems: groupSubfieldsMapByGroupFieldKey[groupFieldKey].map(i => ({
          ...i,
          onClick() {
            addCriteria({ ...i, groupValueUniqueId: uniqueId });
          },
          label: i18next.t(`smartmessaging.massAction.filterLabel.${i.key}`),
        })),
        label: utils.stringFormat(i18next.t('smartmessaging.massAction.addToGroupedFilter'), [
          selectedCriterias[groupFieldKey].groupDisplayNames[uniqueId],
        ]),
      });
    });
  });

  return criteriaMenuItems;
};

const CriteriaMenu = ({
  availaibleCriterias,
  onAddCriteria,
  label,
  isWritable,
  selectedCriterias,
}) => (
  <CascadingMenuItem
    caption={label}
    menuItems={mapCriterias(availaibleCriterias, onAddCriteria, isWritable, selectedCriterias)}
  />
);

CriteriaMenu.propTypes = {
  availaibleCriterias: PropTypes.array.isRequired,
  onAddCriteria: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  isWritable: PropTypes.bool.isRequired,
  selectedCriterias: PropTypes.object,
};
CriteriaMenu.defaultProps = {
  selectedCriterias: {},
};

export default CriteriaMenu;
